export default __webpack_public_path__ + "static/media/device.2d26cb13.jpg";